<p-dialog
  [modal]="true"
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [draggable]="false"
  [style]="{ width: '640px' }"
  [breakpoints]="{ '768px': '92vw' }"
  [header]="'updateNotes.modal.title' | transloco"
  data-testid="update-notes-modal"
>
  <div class="flex max-h-[60vh] flex-col gap-4 overflow-y-auto">
    @for (note of notes(); track note.id) {
      <app-update-note-card [note]="note" />
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex w-full items-center justify-between gap-3">
      <p-button
        [label]="'updateNotes.modal.seeAll' | transloco"
        [text]="true"
        severity="secondary"
        routerLink="/home/updates"
        (onClick)="close()"
      ></p-button>
      <p-button
        [label]="'updateNotes.modal.gotIt' | transloco"
        (onClick)="close()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
